import { FC } from 'react'

import { Settings } from '@/components/layout/settings/layout'
import SettingsTitle from '@/components/layout/settings/title'
import useObject from '@/hooks/useObject'
import { retrieveBranding } from '@/thunks/branding/retrieve'
import fadeIn from '@/util/fadeIn'

import ActiveDomainCard from './Active'
import CustomDomainCard from './Setup'

const Domain: FC = () => {
  const [branding, { set, reload }] = useObject(retrieveBranding, {})

  return (
    <Settings>
      <SettingsTitle
        title="Domain"
        subtitle="By default, SMS messages from Journey include links to demo.journeyid.com. Customize your domain below to
          create branded links and display your company's domain in the browser."
      />

      {branding && (
        <div className={fadeIn(true, 'max-w-xl')}>
          {branding.domain ? (
            <ActiveDomainCard branding={branding} onRefresh={reload} />
          ) : (
            <CustomDomainCard onSuccess={set} />
          )}
        </div>
      )}
    </Settings>
  )
}

export default Domain
